import * as L from 'leaflet';
// import type { IStopArea } from '../../../../models/stop-area.model';
import { TranslationService } from '../../../../services/translation.service';
import { ButtonDivIcon } from '../../../Shared/Map/markers/button-div-icon';
import { ITicketOffice } from '../../../../models/ticket-office.model';
import { SanitizerService } from '../../../../services/sanitizer.service';

export default class TicketOfficeClusterMarker extends L.Marker {
  public id: string;

  constructor(ticketOffice: ITicketOffice, openPopup: boolean = false) {
    super([ticketOffice.latitude ?? 0, ticketOffice.longitude ?? 0], { zIndexOffset: 800 });
    this.id = ticketOffice.number.toString();

    this.setIcon(
      new ButtonDivIcon({
        className: 'button-div-icon ticket-office-marker',
        iconSize: [34, 55],
        iconAnchor: [17, 55],
        popupAnchor: [0, -50],
        html: `<img src="/icons/leaflet/map-marker-ticket-office-blue-1000.svg" alt="${TranslationService.get('common.ticketoffices')} ${SanitizerService.sanitizeHtml(
          ticketOffice.name
        )}" class="w-100 h-100" />`,
      })
    );

    this.bindPopup(this.createPopupHtml(ticketOffice), {
      autoPan: true,
      offset: [0, 0],
    });

    if (openPopup) {
      setTimeout(() => {
        this.openPopup();
      }, 200);
    }

    this.on('popupopen', (popupEvent: L.PopupEvent) => {
      // Inspired by http://melmo.github.io/accessibility/code/dist/leaflet.html
      // Focus on the opened popup
      const stopAreaPopups = popupEvent.popup.getElement()?.getElementsByClassName('ticket-office-popup') ?? [];
      if (stopAreaPopups.length > 0) {
        const stopAreaPopup = stopAreaPopups[0] as HTMLElement;
        stopAreaPopup.setAttribute('tabindex', '-1');
        stopAreaPopup.style.outline = 'none'; // Workaround for hiding built-in focus marker, see NV-4097
        stopAreaPopup.focus();
      }

      // Fix the a11y attributes on the close button
      const closeButtons = popupEvent.popup.getElement()?.getElementsByClassName('leaflet-popup-close-button') ?? [];
      if (closeButtons.length > 0) {
        const closeButton = closeButtons[0] as HTMLLinkElement;
        closeButton.setAttribute('role', 'button');
        closeButton.setAttribute('aria-label', TranslationService.get('common.map.closepopup'));
        closeButton.href = '#';
      }
    });
  }

  private createPopupHtml(ticketOffice: ITicketOffice): string {
    return `<div class="ticket-office-popup">
      <h3 class="ticket-office-popup__name">${ticketOffice.name}</h3>
      <div class="mt-2">${ticketOffice.location}</div>
    </div>`;
  }
}
